import React, {
  useReducer,
  useCallback,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from 'react';
import PropTypes from 'prop-types';
import { Form, Typography, Select, Spin } from 'antd';
import DiseaseSelect from '../../components/DiseaseSelect/DiseaseSelect.js';
import { useLessonsTypeList, usePropertyList } from './hook';

// 属性表单类型枚举
const PropertyFormType = {
  SELECT: '01',
  TREESELECT: '03',
};

const BaseForm = ({ model, onChange, children }, ref) => {
  const initArr = data => {
    let arr = data.map(item => {
      let obj = {
        title: item.name,
        value: item.id.toString(),
        disabled: false,
      };
      if (item.children) {
        obj.children = initArr(item.children);
      }
      return obj;
    });
    return arr;
  };

  const [
    lessonsTypeList,
    lessonsTypeListLoading,
    isEmptyLessonsTypeList,
  ] = useLessonsTypeList();

  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    form,
  }));

  const [form2, dispatchForm2] = useReducer(
    (state, action) => ({ ...state, [action.type]: action.payload }),
    Object.assign(
      { lesion: undefined, labels: '', properties: {}, error: {} },
      model
    )
  );
  const handleChange = useCallback(
    type => event => {
      dispatchForm2({ type, payload: event });
      if (type == 'lesion') {
        let data = lessonsTypeList.find(item => item.value === event);

        dispatchForm2({ type: 'isExam', payload: data.isExam });
        dispatchForm2({ type: 'properties', payload: {} });
      }
    },
    [lessonsTypeList]
  );
  const handlePropertyChange = useCallback(
    key => e => {
      dispatchForm2({
        type: 'properties',
        payload: { ...form2.properties, [key]: e },
      });
    },
    [form2, dispatchForm2]
  );

  // 初始化病变值
  useEffect(() => {
    if (form2.lesion) {
      form.setFieldsValue({ select: form2.lesion });
      if (Object.keys(form2.properties).length) {
        for (let i in form2.properties) {
          let obj = {};
          obj['select' + i] = form2.properties[i];
          form.setFieldsValue(obj);
        }
      }
    }
  }, [form, form2.lesion, form2.properties]);

  useEffect(() => {
    onChange && onChange(form2);
  }, [form2, onChange]);

  const [propertyList, propertyListLoading] = usePropertyList(
    form2.lesion,
    form2.isExam
  );
  // 初始化属性值
  // useEffect(() => {
  //   const data = propertyList.reduce((acc, item) => {
  //     switch (item.type) {
  //       case PropertyFormType.SELECT:
  //         acc[item.id] = item.options.length
  //           ? item.options[0].id.toString()
  //           : '';
  //         break;
  //       case PropertyFormType.TREESELECT:
  //         acc[item.id] = item.examOptionsTree.length
  //           ? item.examOptionsTree[0].id.toString()
  //           : '';
  //         break;
  //     }
  //     return acc;
  //   }, {});
  //   dispatchForm2({
  //     type: 'properties',
  //     payload: data,
  //   });
  // }, [propertyList]);

  return isEmptyLessonsTypeList ? (
    <Typography.Text style={{ marginTop: 8 }} strong type="danger">
      请在核心定义表创建病变
    </Typography.Text>
  ) : (
    <>
      <Spin spinning={lessonsTypeListLoading && propertyListLoading}>
        <Form form={form}>
          <Form.Item
            name="select"
            label="病变"
            hasFeedback
            rules={[{ required: true, message: '请选择病变' }]}
          >
            <Select
              placeholder="请选择病变"
              value={form2.lesion}
              // defaultValue={form2.lesion}
              onChange={handleChange('lesion')}
              options={lessonsTypeList.map(optItem => ({
                label: optItem.key,
                value: optItem.value,
              }))}
            ></Select>
          </Form.Item>
          {propertyList.map((item, index) => {
            switch (item.type) {
              case PropertyFormType.TREESELECT:
                return (
                  <>
                    <Form.Item
                      name={'select' + item.id}
                      label={item.name}
                      hasFeedback
                      key={index}
                      rules={[
                        { required: true, message: '请选择' + item.name },
                      ]}
                    >
                      <DiseaseSelect
                        data={initArr(item.examOptionsTree)}
                        defaultValue={form2.properties[item.id]}
                        onChange={e =>
                          dispatchForm2({
                            type: 'properties',
                            payload: { ...form2.properties, [item.id]: e },
                          })
                        }
                      ></DiseaseSelect>
                    </Form.Item>
                  </>
                );
              case PropertyFormType.SELECT:
                return (
                  <Form.Item
                    name={'select' + item.id}
                    label={item.name}
                    key={index}
                    hasFeedback
                    rules={[{ required: true, message: '请选择' + item.name }]}
                  >
                    <Select
                      placeholder={'请选择' + item.name}
                      options={item.options.map(optItem => ({
                        label: optItem.name,
                        value: optItem.id.toString(),
                      }))}
                      value={form2.properties[item.id]}
                      onChange={handlePropertyChange(item.id)}
                    ></Select>
                  </Form.Item>
                );
            }
          })}
        </Form>
        {children}
      </Spin>
    </>
  );
};
BaseForm.displayName = 'BaseForm';
BaseForm.propTypes = {
  model: PropTypes.object,
  onChange: PropTypes.func,
  children: PropTypes.node,
  ref: PropTypes.any,
};
export default forwardRef(BaseForm);
